module.exports = __webpack_public_path__ + "static/media/house.b2d3c123.png";